import { render } from "./TablePaginator.vue?vue&type=template&id=4e2ae8f0"
import script from "./TablePaginator.vue?vue&type=script&lang=js"
export * from "./TablePaginator.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__